import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import CreatePage from '../../../composents/CreatePage'
import { OWNER } from '../Meters/CreateMeter'

const title = 'Group Of Meters'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'creation of new group',
  breadcrumbs: [
    {
      title: title,
      link: '/meters/groups',
    },
  ],
}

export default function CreateGroupOfMeter() {
  const [loader, setLoader] = useState(false),
    [clients, setClients] = useState([]),
    [client, setClient] = useState(),
    [errors, setErrors] = useState({}),
    [zones, setZones] = useState([]),
    [zone, setZone] = useState(),
    [meters, setMeters] = useState([]),
    [meter, setMeter] = useState(),
    [zonesName, setZonesName] = useState([]),
    [consumers, setConsumers] = useState(null),
    [zoneName, setZoneName] = useState(),
    [ownership, setOwnership] = useState({
      value: 'Public',
      label: 'Public',
    })

  async function onGet() {
    let cli = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cli.status === 200) {
      let a = []
      cli.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
        })
      })

      setClients(a)
    }
    let zoneR = await resources.zone
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (zoneR.status === 200) {
      let a = []
      let b = []
      zoneR.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.location,
          client: el.client._id,
          location: el.location,
        })
        b.push({
          value: el.id,
          label: el.zone,
          location: el.location,
        })
      })

      setZones(
        a.filter(
          (v, i, s) =>
            i ===
            s.findIndex((t) => {
              return t.label === v.label
            })
        )
      )
      setZonesName(b)
    }

    let meter = await resources.meter
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (meter.status === 200) {
      let a = []
      meter.data.docs.forEach((el) => {
        if (!el.group) {
          a.push({
            value: el.id,
            label: el.code,
            client: el?.client?._id,
          })
        }
      })
      setMeters(a)
    }

    let consumers = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (consumers.status === 200) {
      let covertToLabelValue = []
      consumers.data.docs.forEach((el) => {
        covertToLabelValue.push({
          value: el.id,
          label: el.surname,
          client: el.client?.id,
        })
      })
      setConsumers(covertToLabelValue)
    }
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (meter) object.meters = meter.map((e) => e.value)
    object.ownership = ownership.value
    setLoader(true)
    setErrors({})
    let res = await resources.groupOfMeter
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/meters/groups')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterZoneLocation = () => {
    if (client) {
      return zones.filter((e) => e.client === client.value)
    }

    return []
  }

  const filterZoneName = () => {
    if (zone) {
      return zonesName.filter((e) => e.location === zone.location)
    }

    return []
  }

  const filterMeter = () => {
    if (client) {
      return meters.filter((e) => e.client === client.value)
    }

    return []
  }

  const filterConsumers = () => {
    let all_consumers = []

    if (client) {
      all_consumers = consumers.filter((e) => e.client === client.value)
    }
    return all_consumers
  }

  return (
    <CreatePage show_error={errors['not_autorized']} headers={headers}>
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Client <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => {
                      setClient(e)
                      setZone(null)
                      setZoneName(null)
                    }}
                    options={clients}
                    isSearchable
                    isClearable
                    name="client"
                    className={errors['client'] ? ' is-invalid' : ''}
                  />
                  {errors['client'] && <div className="invalid-feedback">{errors['client']}</div>}
                </div>

                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Ownership <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    options={OWNER}
                    isSearchable
                    isClearable={false}
                    value={ownership}
                    onChange={setOwnership}
                    className={errors['ownership'] ? ' is-invalid' : ''}
                  />
                  {errors['ownership'] && (
                    <div className="invalid-feedback">{errors['ownership']}</div>
                  )}
                </div>

                {ownership?.value === 'Private' && (
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Consumer <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                      options={filterConsumers()}
                      isSearchable
                      isClearable
                      name="consumer"
                      className={errors['consumer'] ? ' is-invalid' : ''}
                    />
                    {errors['consumer'] && (
                      <div className="invalid-feedback">{errors['consumer']}</div>
                    )}
                  </div>
                )}

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Zone location <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => {
                      setZone(e)
                      setZoneName(null)
                      setMeter(null)
                    }}
                    value={zone}
                    options={filterZoneLocation()}
                    isSearchable
                    isClearable
                  />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Zone name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => {
                      setZoneName(e)
                      setMeter(null)
                    }}
                    options={filterZoneName()}
                    isSearchable
                    isClearable
                    value={zoneName}
                    name="zone"
                    className={errors['zone'] ? ' is-invalid' : ''}
                  />
                  {errors['zone'] && <div className="invalid-feedback">{errors['zone']}</div>}
                </div>

                <Field name="name" className="mb-3" error={errors['zone']} required>
                  Group name
                </Field>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Meters
                  </label>
                  <Select
                    onChange={setMeter}
                    value={meter}
                    options={filterMeter()}
                    isSearchable
                    isClearable
                    isMulti
                  />
                </div>

                <Field
                  name="description"
                  type="textarea"
                  error={errors['description']}
                  className="mb-3"
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}
